<template>
  <BaseButton primary small @click="showUploadAssetsDialog"> Upload Assets </BaseButton>
</template>

<script>
export default {
  props: {
    action: {
      type: Function,
      required: true,
    },
  },
  methods: {
    showUploadAssetsDialog() {
      this.$modal.show({
        component: () => import('./UploadAssetsDialog.vue'),
        props: {
          action: this.action,
        },
        on: {},
        hideEvent: 'close',
      });
    },
  },
};
</script>
